import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useIsMobile } from '../../../../../hooks/useIsMobile'
import { useIsTablet } from '../../../../../hooks/useIsTablet'
import {
  getChallengeById,
  getTemplateById,
  getUserEventById
} from '../../../../../redux/apis'
import { FEED_RESET } from '../../../../../redux/constants'
import { setLocationState } from '../../../../../redux/designerReducers/locationStateReducer'
import { fetchFeed, setAttr } from '../../../../../redux/feedInfiniteSlice'
import { CaptionModal } from '../../../../../components/CaptionModal'
import {
  convertDataToArtboard,
  convertiOSDataToArtboard
} from '../../../../../utils/fetchUtils'
import { getUserEventRequirements } from '../../../../../utils/userEvent'
import DesignFeed from '../../DesignFeed'
import DraftsFeed from '../../DraftsFeed'
// import MyEvent from '../../MyEvent'
import BasicDesignCard from '../BasicDesignCard'
import DesignTabs from '../DesignTabs'
import ProfileInfo from '../ProfileInfo'
import { Container, FeedContainer } from './Designs.styles'
import { logEvent } from '../../../../../utils/firebase'

const imgload = async url => {
  const img = new Image()
  img.src = url
  await img.decode()
  return { w: img.width, h: img.height }
}

const optionsMyDesktop = [
  {
    value: 'posts',
    label: 'Designs'
  },
  {
    value: 'drafts',
    label: 'Drafts'
  },
  {
    value: 'saved',
    label: 'Collection'
  }
]

const optionsMyTablet = [
  {
    value: 'info',
    label: 'Info'
  },
  {
    value: 'posts',
    label: 'Designs'
  },
  {
    value: 'drafts',
    label: 'Drafts'
  },
  {
    value: 'saved',
    label: 'Collection'
  }
]

const optionsOthersDesktop = [
  {
    value: 'posts',
    label: 'Posts'
  }
]

const optionsOthersTablet = [
  {
    value: 'info',
    label: 'Info'
  },
  {
    value: 'posts',
    label: 'Designs'
  }
]

export const Designs = ({ userid, isOthers, openCoinsHistory }) => {
  const dispatch = useDispatch()
  const isTablet = useIsTablet()
  const isMobile = useIsMobile()
  const router = useRouter()
  const optionsMy = isTablet || isMobile ? optionsMyTablet : optionsMyDesktop
  const optionsOthers =
    isTablet || isMobile ? optionsOthersTablet : optionsOthersDesktop
  const objectId = useSelector(state => state.profile.me?.objectId)
  const options = objectId === userid ? optionsMy : optionsOthers
  const [selectedTab, setSelectedTab] = useState(options[0])
  const inspiration = useSelector(state => state.inspiration)
  const saved = useSelector(state => state.saved)
  const drafts = useSelector(state => state.drafts)
  const [editPost, setEditPost] = useState(null)

  useEffect(() => {
    const preselect = router.asPath.split('#')[1]
    const option = preselect
      ? options.find(option => option.value === preselect)
      : options[0]

    if (option) setSelectedTab(option)
  }, [isMobile, isTablet, options, router.asPath.split('#')[1]])

  useEffect(() => {
    if (!selectedTab) return

    window.location.hash = selectedTab?.value
  }, [selectedTab])

  useEffect(() => {
    if (!userid) return

    var attr = {
      addition: {
        userId: userid
      }
    }

    switch (selectedTab?.value) {
      case 'posts':
        dispatch(setAttr('inspiration')(attr))
        dispatch(fetchFeed('inspiration')({ status: FEED_RESET }))
        break
      case 'drafts':
        dispatch(fetchFeed('drafts')({ status: FEED_RESET }))
        break
      case 'saved':
        dispatch(
          setAttr('saved')({
            addition: {
              types: ['design', 'pgc', 'blog', 'contest']
            }
          })
        )
        dispatch(fetchFeed('saved')({ status: FEED_RESET }))
        break
      default:
        break
    }
  }, [dispatch, userid, selectedTab])

  const handleFetchMore = type => () => {
    dispatch(fetchFeed(type)({ status: null }))
  }

  const handlePostClick = (e, data) => {
    console.log(data)

    if (!data) return

    router.push('/design/' + data.objectId)
  }

  const handleSavedClick = (e, data) => {
    console.log(data)

    if (!data) return

    router.push('/design/' + data?.userInspiration?.objectId)
  }

  const handleDraftClick = async (event, data) => {
    event.stopPropagation()

    const from = 'profile'

    logEvent('draft_continue', {
      content_type: 'draft',
      content_id: data.objectId
    })

    if (!data) return

    if (data?.designContest?.objectId) {
      const challengeResult = await getChallengeById(
        data.designContest.objectId
      )

      //------------
      // Get Template Natural Dimensions
      const template = new Image()

      if (data.collection) {
        const collection = data.collection
        var url
        if (collection.ext['webp']) {
          url = collection.cdn + collection.key + '-1024w.webp'
        } else {
          url = collection.cdn + collection.key + '-1024w.jpeg'
        }
        template.src = url + '?no-cache'
      } else if (data.cfBgImageUrl)
        template.src = data.cfBgImageUrl + '?no-cache2'

      template.crossOrigin = 'anonymous'
      await template.decode()
      //------------

      var requirements = []
      if (
        challengeResult.specialRequirements &&
        challengeResult.specialRequirements.tasks
      )
        requirements = challengeResult.specialRequirements.tasks

      dispatch(
        setLocationState({
          idea: convertDataToArtboard(
            data.objectId,
            data.cfBgImageUrl,
            data.items,
            template.naturalWidth,
            template.naturalHeight
          ),
          fromDraft: true,
          type: 'challenge',
          markers: challengeResult.buttons,
          requirements,
          challengeId: challengeResult.objectId,
          from,
          designData: challengeResult
        })
      )

      router.push(
        `/create/challenge/${data.designContest.objectId}/${data.objectId}`
      )

      return
    } else if (data?.userEvent?.objectId) {
      getUserEventById(data?.userEvent?.objectId).then(r => {
        const requirements = getUserEventRequirements(r)

        dispatch(
          setLocationState({
            idea: convertDataToArtboard(
              data.objectId,
              data.cfBgImageUrl,
              data.items
            ),
            fromDraft: true,
            type: 'userEvent',
            markers: r.buttons,
            requirements,
            userEventId: r.objectId,
            from,
            designData: r
          })
        )

        router.push(
          `/create/userEvent/${data.userEvent.objectId}/${data.objectId}`
        )
      })

      return
    }

    var templateData = null

    if (data.templateId) {
      //console.error("*** NEED TO LOAD TEMPLATE DATA! ***")
      templateData = await getTemplateById(data.templateId)
    }

    //------------
    // Get Template Natural Dimensions
    const template = new Image()
    template.src =
      (data.cfBgImageUrl?.url || data.cfBgImageUrl) + '?not-from-cache-please'
    template.crossOrigin = 'anonymous'
    await template.decode()
    //------------

    //Set up items using items data
    if (data.items) {
      dispatch(
        setLocationState({
          idea: convertDataToArtboard(
            data.objectId,
            data.cfBgImageUrl,
            data.items,
            template.naturalWidth,
            template.naturalHeight
          ),
          fromDraft: true,
          type: 'drafts',
          from,
          designData: templateData
        })
      )

      router.push(`/create/design/${data.objectId}`)
      return
    }

    //Set up items using productsWithPosition data
    if (data.productsWithPosition && data.productsWithPosition.length > 0) {
      var prods = [...data.productsWithPosition]
      for (var i = 0; i < prods.length; i++) {
        const dim = await imgload(prods[i].imageUrl)
        prods[i] = {
          ...prods[i],
          w: dim.w,
          h: dim.h
        }
      }

      dispatch(
        setLocationState({
          idea: convertiOSDataToArtboard(
            data.objectId,
            data.cfBgImageUrl,
            prods,
            data,
            template.naturalWidth,
            template.naturalHeight
          ),
          fromDraft: true,
          type: 'drafts',
          from,
          designData: templateData
        })
      )
      router.push(`/create/design/${data.objectId}`)
      return
    }

    dispatch(
      setLocationState({
        idea: convertDataToArtboard(
          data.objectId,
          data.cfBgImageUrl,
          data.items,
          template.naturalWidth,
          template.naturalHeight
        ),
        fromDraft: true,
        type: 'drafts',
        from,
        designData: templateData
      })
    )

    router.push(`/create/design/${data.objectId}`)
  }

  return (
    <>
      <Container>
        <DesignTabs
          options={options}
          selected={selectedTab}
          onChange={e => setSelectedTab(e)}
        />
        {selectedTab?.value === 'info' && (
          <ProfileInfo
            isOthers={isOthers}
            openCoinsHistory={openCoinsHistory}
          />
        )}
        <FeedContainer id="posts-scroll-box">
          {selectedTab?.value === 'posts' && (
            <DesignFeed
              data={inspiration.feed}
              onFetch={handleFetchMore('inspiration')}
              card={props => {
                return (
                  <BasicDesignCard
                    {...props}
                    topButtons="menu"
                    fromOwner={objectId === userid}
                    setEditPost={setEditPost}
                  />
                )
              }}
              loading={inspiration.loading}
              error={inspiration.error}
              onClick={handlePostClick}
            />
          )}
          {selectedTab?.value === 'drafts' && (
            <DraftsFeed
              data={drafts.feed}
              onFetch={handleFetchMore('drafts')}
              card={props => (
                <BasicDesignCard
                  {...props}
                  topButtons="menu"
                  bottomButtons="none"
                  fromOwner
                  drafts
                  mode="drafts"
                />
              )}
              loading={drafts.loading}
              error={drafts.error}
              onClick={handleDraftClick}
            />
          )}
          {selectedTab?.value === 'saved' && (
            <DesignFeed
              data={saved.feed}
              onFetch={handleFetchMore('saved')}
              card={props => (
                <BasicDesignCard {...props} showAuthor topButtons="menu" />
              )}
              loading={saved.loading}
              error={saved.error}
              onClick={handleSavedClick}
            />
          )}
        </FeedContainer>
      </Container>
      {editPost && (
        <CaptionModal data={editPost} handleClose={() => setEditPost(null)} />
      )}
    </>
  )
}
